import { useEffect, useState } from "react";
import {
  ProductCardPriceInfo,
  convertTimeFormat,
  getEntityType,
  getProcureInfo,
  goToModuleDetail,
  redirectToPageUtil,
} from "../../utils/AppUtils";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAssignBrokerCourseClear,
  getAssignCourseClear,
} from "../../redux/courses/actions";
import ErrorSection from "../ErrorPage/ErrorSection";
import ProductCardComponent from "../NewDesign/ProductCard/ProductCardComponent";
import ProductCardLpDetail from "../NewDesign/ProductCardLPDetail/ProductCardLpDetail";
import ShimmerScreen from "../Layouts/ShimmerScreen";
import TitleLogoComponent from "../NewDesign/Misc/TitleLogo/TitleLogoComponent";
import DetailPageDescComponent from "../NewDesign/Misc/DetailPageDesc/DetailPageDescComponent";
import TitleTagsComponent from "../NewDesign/Misc/TitleTags/TitleTagsComponent";
import DetailPageTitleComponent from "../NewDesign/Misc/DetailPageTitle/DetailPageTitleComponent";
import CheckListApprPopUp from "../../pages/menuPages/CheckListApprPopUp";
import { getActiveHeader } from "../../redux/home/actions";
import { useTranslation } from "react-i18next";
import Loader from "../Loader/Loader";

const LPdetailComp = (props) => {
  const {
    showShimmer,
    contentList,
    lpDetail,
    is_learn_more,
    hideForBundle,
    fromPage,
    isMobile
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
const {t} = useTranslation();
  const search = window.location.search;
  const params = new URLSearchParams(search);
  // const program_id = params.get('program_id');
  // const level_id = params.get('level_id');
  // const lp_id = params.get('lp_id');
  // const fromLevel = params.get('is_level')
  // const source = params.get('source')

  const c = params.get("c");
  let decodedString = atob(c);
  let paramsReq = JSON.parse(decodedString);
  const program_id = paramsReq?.program_id;
  const level_id = paramsReq?.level_id;
  const lp_id = paramsReq?.lp_id;
  const fromLevel = paramsReq?.is_level;
  const source = paramsReq?.source;
  const ob_lp_flag = paramsReq?.ob_lp_flag;
  const provider_name = paramsReq?.provider_name;

  // CONFIG.INITIAL_PRODUCT_CARD_DATA
  const authBroker = useSelector((state) => state.auth.authBroker);
  const assignCourse = useSelector((state) => state.courses.assignCourse);
  const assignBrokerCourse = useSelector(
    (state) => state.courses.assignBrokerCourse
  );

  const [courseData, setCourseData] = useState({});
  const [contentShowList, setContentShowList] = useState([]);
  const [providerLogoURL, setProviderLogoURL] = useState("");
  const [tagsArray, setTagsArray] = useState([]);
  const [showCL, setShowCL] = useState(false);
  const [checkListLp, setCheckListLp] = useState("");

  useEffect(() => {
    setTimeout(() => {
      if(_.isEmpty(provider_name)){
      dispatch(getActiveHeader("learn"))  } 
    }, 1000);
  }, []);

  useEffect(() => {
    let prodArr = [];
    if (!_.isEmpty(contentList))
      for (let [index, course] of contentList.entries()) {
        let tags = [];
        let btnTitle = t("Start course");
        if (course.provider?.provider_display_name) {
          tags.push(course.provider.provider_display_name);
        }
        tags.push(getEntityType(course.entity_type));

        if (course.entity_type === "video") {
          tags.push(`${course.views} View${course.views > 1 ? "s" : ""}`);
        }

        if (course.entity_type === "learningpath" && course.lessons) {
          if (course.course_count > 0)
            tags.push(
              `${course.course_count} Step${
                course.course_count > 1 ? "s" : ""
              }`
            );
          if (course.video_count > 0)
            tags.push(
              `${course.video_count} Video${course.video_count > 1 ? "s" : ""}`
            );
          if (course.event_count > 0)
            tags.push(
              `${course.event_count} Event${course.event_count > 1 ? "s" : ""}`
            );
        }
        if (course.entity_type === "course" && course.lessons) {
          tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
        }
        // if (course.entity_type === "video") {
        //     tags.push(`Video`)
        // }
        if (course.entity_type === "event" && course.lessons) {
          tags.push(
            `${course.session_count} Session${course.lessons > 1 ? "s" : ""}`
          );
        } else if (course.entity_type === "level") {
          if (course.course_count > 0)
            tags.push(
              `${course.course_count} Step${
                course.course_count > 1 ? "s" : ""
              }`
            );
          if (course.video_count > 0)
            tags.push(
              `${course.video_count} Video${course.video_count > 1 ? "s" : ""}`
            );
          if (course.event_count > 0)
            tags.push(
              `${course.event_count} Event${course.event_count > 1 ? "s" : ""}`
            );
        }

        // alert(course.duration)
        if (course.duration) {
          tags.push(`${course.duration}`);
          // debugger
        }

        if (
          course.crs_progress === "" ||
          course.crs_progress === undefined ||
          course.crs_progress === null ||
          course.crs_progress === 0
        ) {
          btnTitle = t("Start course");
        }

        if (course.crs_progress > 0 && course.crs_progress < 100) {
          btnTitle = t("Resume course");
        } else if (course.crs_progress >= 100) {
          btnTitle = t("Revisit course");
        }

        if (
          ((course?.source === "ecom" || course?.source === "xsel") &&
            !course?.is_paid) ||
          course?.entity_type === "level" ||
          course?.entity_type === "learningpath"
        ) {
          btnTitle = t("Explore");
        }

        let priceInfo = getProcureInfo(course.purchased_info);
        course.priceInfo = priceInfo;

        if (course?.entity_type === "event") {
          // tags = [];
          btnTitle = t("Explore");
        }

        if (course?.entity_type === "video") {
          // tags = [];
          btnTitle = t("View");
        }

        prodArr.push({
          id: course.id,
          title: course.name,
          logoURL: course.provider?.provider_img
            ? course.provider?.provider_img
            : "",
          bannerURL: course.imageURL,
          tagsArray: tags,
          description: course.long_description ? course.long_description : "",
          btnTitle: btnTitle,
          progress: course.crs_progress,
          btnAction: () => {
            if(isMobile){
              if (course.isLock) {
                return;
            }
              let obj = {type: course?.entity_type, obj: course, method:"learn-to-more-section", lp_id: lp_id }
              console.log("learn-to-more",JSON.stringify(obj));
                  if (window.callbackHandler != undefined) {
                      window.callbackHandler.postMessage(
                        JSON.stringify(obj)
                      );
                    } else if (window.webkit != undefined) {
                      if (
                        window.webkit.messageHandlers.callbackHandler !=
                        undefined
                      ) {
                        window.webkit.messageHandlers.callbackHandler.postMessage(
                          JSON.stringify(obj)
                        );
                      }
                    }
              return;
            }

            course.entity_type === "event" ||
            course.entity_type === "video" ||
            course.entity_type === "level"
              ? navigateToView(course)
              : redirectToPageUtil(
                  course,
                  navigate,
                  authBroker,
                  setCourseData,
                  dispatch,
                  fromPage,
                  lp_id,
                  source,
                  fromLevel,
                  level_id
                )},
          descAction: {},
          bannerAction: () => {
            if(isMobile){
              if (course.isLock) {
                return;
            }
              let obj = {type: course?.entity_type, obj: course, method:"learn-to-more-section" }
                  if (window.callbackHandler != undefined) {
                      window.callbackHandler.postMessage(
                        JSON.stringify(obj)
                      );
                    } else if (window.webkit != undefined) {
                      if (
                        window.webkit.messageHandlers.callbackHandler !=
                        undefined
                      ) {
                        window.webkit.messageHandlers.callbackHandler.postMessage(
                          JSON.stringify(obj)
                        );
                      }
                    }
              return;
            }

            course.entity_type === "event" ||
            course.entity_type === "video" ||
            course.entity_type === "level"
              ? navigateToView(course)
              : redirectToPageUtil(
                  course,
                  navigate,
                  authBroker,
                  setCourseData,
                  dispatch,
                  fromPage,
                  lp_id,
                  source,
                  fromLevel,
                  level_id
                )},
          footerLineComp: !_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : "",
          showHeader: true,
          showProviderIcon: true,
          showBody: course.long_description ? true : false,
          showFooter: hideForBundle ? false : true,
          showProgress: hideForBundle ? false : true,
          showBtn: hideForBundle ? false : true,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",
          isLock: course.isLock,
          tooltip: course.is_manager_checklist && course.isLock
            ? "Notification sent to your manager, please discuss before moving forward."
            : "",
          is_checklist_approved: course.is_checklist_approved,
          checklist_approved_by: course.checklist_approved_by,
          is_checklist_present: course.is_checklist_present,
          showUpdatedTag: course.lp_updated === 1,
          clInfo: course.clInfo,
          asset_type: course.asset_type,
          asset_id: course.asset_id,
          duration: course.duration,
          monitoring_name: course.monitoring_name,
          asset_icon: course?.asset_icon,
          monitoring_icon: course?.monitoring_icon
        });
      }
    setContentShowList(prodArr);
  }, [contentList]);

  const navigateToView = (data) => {
    if (data.isLock) {
      return;
    }

    if (data.entity_type === "event") {
      let paramsReq = {
        event_id: data.id,
        event_code: data?.crscd,
        source: data.source,
        lp_id: lp_id,
        from: fromPage,
        lp_source: source,
      };
      if (level_id) {
        paramsReq.level_id = level_id;
        paramsReq.is_level = "true";
      }
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);

      let url = `/event-detail?c=${encodedUrl}`;
      // let url = `/event-detail?event_id=${data.id}`
      // url = url + `&event_code=${data?.crscd}` + `&source=${data.source}`
      navigate(url);
    } else if (data.entity_type === "video") {
      let paramsReq = {
        code: data.crscd,
        source: data.source,
        is_paid: "false",
        lp_id: lp_id,
        via_lp: "true",
        from: fromPage,
        lp_source: source,
      };
      if (level_id) {
        paramsReq.level_id = level_id;
        paramsReq.is_level = "true";
      }

      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      // let url = `/video-view-page/${data.id}/?source=${data.source}&code=${data.crscd}&is_paid=${false}`
      // url = url + `&lp_id=${lp_id}&via_lp=true&lp_source=${source}`
      // if (level_id) {
      //     url = url + `&level_id=${level_id}&is_level=true`
      // }
      // if (!_.isEmpty(data.id)) {
      //     url += `&catId=${data?.categoryId[0]}`
      // }
      let url = `/video-view-page/${data.id}/?c=${encodedUrl}`;
      navigate(url);
    } else {
      let paramsReq = {
        lp_id: lp_id,
        level_id: data.id,
        is_level: "true",
        source: source,
      };
      let jsonString = JSON.stringify(paramsReq);
      let encodedUrl = btoa(jsonString);
      // navigate(`/levelDetail?lp_id=${lp_id}&level_id=${data.id}&is_level=true&source=${source}`)
      navigate(`/levelDetail?c=${encodedUrl}`);
    }
  };

  useEffect(() => {
    // console.log("assignCourse", assignCourse, courseData);
    if (assignCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignCourseClear());
      goToModuleDetail(
        courseData,
        navigate,
        fromPage,
        lp_id,
        source,
        fromLevel,
        level_id
      );
    }
  }, [assignCourse, courseData]);

  useEffect(() => {
    if (assignBrokerCourse?.status === "success" && !_.isEmpty(courseData)) {
      dispatch(getAssignBrokerCourseClear());
    }
  }, [assignBrokerCourse]);

  useEffect(() => {
    if (lpDetail.prgm_nm) {
      let tags = [];
      setProviderLogoURL(lpDetail?.provider?.provider_img);
      // if (!_.isEmpty(lpDetail.provider)) {
      //   tags.push(lpDetail.provider.provider_display_name);
      // }
      if (fromPage != "bundle") {
        // tags.push("Action Path");
      }
      // tags.push(fromPage==='bundle'?`Combo`:`Action Path`);

      
      if (lpDetail.learningpath_count) {
        tags.push(
          `${lpDetail.learningpath_count} Action Path${lpDetail.learningpath_count > 1 ? "s" : ""}`
        );
      }
      if (lpDetail.course_count) {
        tags.push(
          `${lpDetail.course_count} Step${
            lpDetail.course_count > 1 ? "s" : ""
          }`
        );
      }
      if (lpDetail.video_count) {
        tags.push(
          `${lpDetail.video_count} Video${lpDetail.video_count > 1 ? "s" : ""}`
        );
      }
      if (lpDetail.level_count) {
        tags.push(
          `${lpDetail.level_count} Level${lpDetail.level_count > 1 ? "s" : ""}`
        );
      }
      if (lpDetail.event_count) {
        tags.push(
          `${lpDetail.event_count} Event${lpDetail.event_count > 1 ? "s" : ""}`
        );
      }
      if (lpDetail.duration) {
        tags.push(lpDetail.duration);
      }
      setTagsArray(tags);
    }
  }, [lpDetail]);

  const handleCLClose = () => {
    setShowCL(false);
  };

  return (
    <>
    <Loader start={showShimmer} />
    <div class="action-sec-inner">
                <div class="banner-box">
                  <div class="img-box-banner">
                  {showShimmer?"":<img src={lpDetail?.banner ? lpDetail?.banner : "/images/finwell-img/action-banner.png"} alt="action path banner" class="img-fluid" />}
                  </div>
                  <ul>
                    <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.58197 8.25H8.83197V9H3.58197V8.25Z" fill="#415385" />
                      <path d="M8.83197 6H3.58197V6.75H8.83197V6Z" fill="#415385" />
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M1.33197 0H7.62861L10.668 3.38043V12H1.33197V0ZM9.6216 3.30652L7.72846 0.995845V3.30652H9.6216ZM9.96651 3.82389V11.2985H2.03347V0.7015H7.02696V3.82389H9.96651Z"
                        fill="#415385" />
                      <path
                        d="M7.63197 0L10.668 3.384L10.668 12H1.33197V0H7.63197ZM7.03197 0.696H2.03997V11.304H9.97197V3.828H7.03197V0.696ZM8.83197 8.244L8.83197 9H3.58797V8.244H8.83197ZM8.83197 6L8.83197 6.744H3.58797V6H8.83197ZM7.72797 0.996V3.3H9.62397L7.72797 0.996Z"
                        fill="#415385" />
                    </svg> Action Path</li>
                    <li><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_3626_44634)">
                        <path
                          d="M11.295 2.52H3.01333L2.32667 1.85833H10.5733V1.11833L1.58667 1.15833L1 0.61H9.725V0.005L0.345001 0V9.905L2.58833 12H11.295C11.4933 12 11.655 11.835 11.655 11.6333V2.88667C11.655 2.68333 11.4933 2.52 11.295 2.52ZM2.49833 10.905L1.08833 9.64167L1.13167 1.73167L2.54167 3.05833L2.49833 10.905ZM5.09667 3.25833H8.24667V7.37333L6.67167 6.345L5.09667 7.37333V3.25833ZM3.24 11.26V3.25833H4.35334V8.74833L6.67167 7.23333L8.99 8.74833V3.25833H10.9367V11.26H3.24Z"
                          fill="#415385" />
                      </g>
                      <defs>
                        <clipPath id="clip0_3626_44634">
                          <rect width="12" height="12" fill="white" />
                        </clipPath>
                      </defs>
                    </svg> {lpDetail?.monitoring_name}</li>
                    {tagsArray?.map((item,index)=>{return <li>{item}</li>})}
                  </ul>
                  <DetailPageTitleComponent
                    title={lpDetail?.prgm_nm}
                    isLoading={showShimmer}
                  />
                  <DetailPageDescComponent
                    desc={lpDetail?.prgm_description}
                    isLoading={showShimmer}
                  />
                </div>

                

                {contentShowList.length === 0 && !showShimmer ? (
          <ErrorSection />
        ) : (
          contentShowList.map((course, i) => {
            return (
              <ProductCardLpDetail
                {...course}
                key={`course-${i + 1}`}
                lastKey={contentShowList.length === i + 1}
                refInfo={contentShowList}
                is_learn_more={is_learn_more}
                setShowCL={setShowCL}
                setCheckListLp={setCheckListLp}
              />
            );
          })
        )}
                


              </div>

      {false && <div className={is_learn_more ? 'module-learn-text mt-0' : 'module-learn-text'}>
        {showShimmer ? (
          <div className="mgt30 mt-4">
            <ShimmerScreen case={"rect"} width={"100%"} height={"30px"} />
          </div>
        ) : (
          <>
            <div className="left-panel">
              <div className="module-learn-text mt-0">
                {is_learn_more ? (
                  <>
                    <h2 className="mgt30">{t("There's more to Learn")}</h2>
                    <div className="smalltext-videolist">
                      {t("Continue with")} {lpDetail.prgm_nm}
                    </div>
                  </>
                ) : (
                  <DetailPageTitleComponent
                    title={lpDetail?.prgm_nm}
                    isLoading={showShimmer}
                  />
                )}
                {is_learn_more ? (
                  ""
                ) : (
                  <div className="d-flex box-meta">
                    {/* {providerLogoURL && (
                    )} */}
                      <div className="img-box-meta">
                        <TitleLogoComponent
                          logoURL={providerLogoURL}
                          altText={""}
                          isLoading={showShimmer}
                        />
                      </div>
                    <div className="meta-lsit">
                      <TitleTagsComponent
                        tagsArray={tagsArray}
                        isLoading={showShimmer}
                      />
                    </div>
                  </div>
                )}
                {is_learn_more ? (
                  ""
                ) : (
                  <DetailPageDescComponent
                    desc={lpDetail?.prgm_description}
                    isLoading={showShimmer}
                  />
                )}
              </div>
            </div>
            {/* <h2 className="mgt30 mt-4">{lpDetail?.prgm_nm}</h2> */}
          </>
        )}
       
        {contentShowList.length === 0 && !showShimmer ? (
          <ErrorSection />
        ) : (
          contentShowList.map((course, i) => {
            return (
              <ProductCardLpDetail
                {...course}
                key={`course-${i + 1}`}
                lastKey={contentShowList.length === i + 1}
                refInfo={contentShowList}
                is_learn_more={is_learn_more}
                setShowCL={setShowCL}
                setCheckListLp={setCheckListLp}
              />
            );
          })
        )}
      </div>}
      <CheckListApprPopUp
        show={showCL}
        handleClose={handleCLClose}
        checkListLp1={checkListLp}
        setApprovalStatus={() => {}}
        approvalStatus={""}
        setIsLoading={() => {}}
        setConfirmMesg={() => {}}
        confirmMesg={""}
        setConfirmModal2={() => {}}
        tabKey={""}
        reloadData={() => {}}
        noAction={true}
      />
    </>
  );
};
export default LPdetailComp;
